import { ChangeDetectionStrategy, Component } from '@angular/core'

import { CmpTestimonial } from 'app/core/cms/generated/api-types'
import { PictureComponent } from 'app/shared/picture/picture.component'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-cmp-testimonial',
  templateUrl: './cmp-testimonial.component.html',
  styleUrls: ['./cmp-testimonial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PictureComponent, PictureComponent],
  providers: [{ provide: CmsBlock, useExisting: CmpTestimonialComponent }],
})
export class CmpTestimonialComponent extends CmsBlock<CmpTestimonial> {
  readonly __typename = 'CmpTestimonial'
}
